window.Products.Clothing.ShirtMilltex901 = function() {
};
window.Products.Clothing.ShirtMilltex901.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ShirtMilltex901.dpi = 150;
window.Products.Clothing.ShirtMilltex901.has_3d = true;
window.Products.Clothing.ShirtMilltex901.id = 93;
window.Products.Clothing.ShirtMilltex901.slug = 'shirt-milltex-901';
window.Products.Clothing.ShirtMilltex901.syncColors = true;
window.Products.Clothing.ShirtMilltex901.texturesLoaded = 0;
window.Products.Clothing.ShirtMilltex901.texturesLoading = false;
window.Products.Clothing.ShirtMilltex901.use_glb = true;

window.Products.Clothing.ShirtMilltex901.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	object.children[1].material.color = three_color;
	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.color = three_color;
	}

	me.updateThreeTexture(modelViewer);
	var three_intensity = 1.5;

	if(color == "grey" || color == "charcoal" || color == "navy"){
		three_intensity = 2.5;
	}

	object.children[me.outsideObject].material.aoMapIntensity = three_intensity;

	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.aoMapIntensity = three_intensity;
	}
};

window.Products.Clothing.ShirtMilltex901.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"grey": 0x939290,
		"red": 0xa2393c,
		"charcoal": 0x393336,
		"navy": 0x464654,
		"black": 0x171616,
	};

	return new THREE.Color(colors[_name]);
};